export const limitNumber = (number: number, limit = 99) => {
	if (number > limit) {
		return `${limit}+`;
	}

	return `${number}`;
};
